import { useMemo } from 'react';

import { ReactSVG, Props as ReactSVGProps } from 'react-svg';

import { ASSETS_MAP } from 'assets';
import { IThemePalette } from 'theme/custom/theme';
import { NestedKeyOf } from 'types/utils';
import { getValueFromObjectPath } from 'utils/getValueFromObjectPath';

type PartialReactSVGProps = Omit<ReactSVGProps, 'ref' | 'src' | 'wrapper'>;

export type SVGAssetProps = PartialReactSVGProps & {
    src: NestedKeyOf<typeof ASSETS_MAP>;
    color?: NestedKeyOf<Omit<IThemePalette, 'gradients' | 'glass' | 'grey'>>;
};

export const SVGAsset = (props: SVGAssetProps): JSX.Element => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { src, className, color, children, ...rest } = props;

    const classNames = [className, 'svg-asset', ...src.split('.')]
        .filter((c) => !!c)
        .join(' ');

    const source = useMemo(() => {
        return getValueFromObjectPath(ASSETS_MAP, src);
    }, [src]);

    return (
        <ReactSVG
            {...rest}
            wrapper="span"
            className={classNames}
            src={source}
        />
    );
};
